export function SplashScreen() {
  return <main className="asf-centered" data-testid="asf-splash" />
}
